/**
 * Comprehensive Phrases Data - Middle School Grade 7
 * 初中七年级短语集合
 *
 * 包含初中基础表达和进阶语法，约50个短语
 */

import { Phrase } from './phrases-types';

export const middleSchoolGrade7Phrases: Phrase[] = [
  // ==================== 高级日常表达 Advanced Daily Expressions ====================

  // 复杂句型
  {
    id: 'ms7_used_to',
    phrase: 'used to',
    phonetic: '/ˈjuːzd tuː/',
    meaning: '过去常常',
    usageScenario: '描述过去经常做但现在不再做的事',
    example: 'I used to play basketball when I was young.',
    exampleTranslation: '我年轻时经常打篮球。',
    category: 'daily_expressions',
    difficulty: 'hard',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_be_used_to',
    phrase: 'be used to',
    phonetic: '/biː ˈjuːzd tuː/',
    meaning: '习惯于',
    usageScenario: '描述已经习惯某事或做某事',
    example: 'I am used to getting up early.',
    exampleTranslation: '我习惯早起。',
    category: 'daily_expressions',
    difficulty: 'hard',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_look_forward_to',
    phrase: 'look forward to',
    phonetic: '/lʊk ˈfɔːrwərd tuː/',
    meaning: '期待',
    usageScenario: '表达对未来的期待或盼望',
    example: 'I look forward to seeing you.',
    exampleTranslation: '我期待见到你。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_prefer_to',
    phrase: 'prefer...to...',
    phonetic: '/prɪˈfɜːr tuː/',
    meaning: '更喜欢……而不是……',
    usageScenario: '表达在两者之间更偏好其中一个',
    example: 'I prefer tea to coffee.',
    exampleTranslation: '比起咖啡，我更喜欢茶。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_would_rather',
    phrase: 'would rather',
    phonetic: '/wʊd ˈræðər/',
    meaning: '宁愿',
    usageScenario: '表达更愿意做某事',
    example: 'I would rather stay at home.',
    exampleTranslation: '我宁愿待在家里。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_had_better',
    phrase: 'had better',
    phonetic: '/hæd ˈbetər/',
    meaning: '最好',
    usageScenario: '给出建议或警告',
    example: 'You had better study hard.',
    exampleTranslation: '你最好努力学习。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },

  // ==================== 被动语态 Passive Voice ====================

  {
    id: 'ms7_be_made_of',
    phrase: 'be made of',
    phonetic: '/biː meɪd əv/',
    meaning: '由……制成（看得出原材料）',
    usageScenario: '描述物品的材料，能看出原材料',
    example: 'The table is made of wood.',
    exampleTranslation: '这张桌子是由木头制成的。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_be_made_from',
    phrase: 'be made from',
    phonetic: '/biː meɪd frɒm/',
    meaning: '由……制成（看不出原材料）',
    usageScenario: '描述物品的材料，看不出原材料',
    example: 'Paper is made from wood.',
    exampleTranslation: '纸是由木头制成的。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_be_used_for',
    phrase: 'be used for',
    phonetic: '/biː juːzd fɔːr/',
    meaning: '被用来……',
    usageScenario: '描述物品的用途',
    example: 'Knives are used for cutting.',
    exampleTranslation: '刀被用来切割。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_be_called',
    phrase: 'be called',
    phonetic: '/biː ˈkɔːld/',
    meaning: '被称为',
    usageScenario: '描述事物的名称',
    example: 'The city is called Beijing.',
    exampleTranslation: '这座城市被称为北京。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_be_known_as',
    phrase: 'be known as',
    phonetic: '/biː noʊn æz/',
    meaning: '被称为/作为……而闻名',
    usageScenario: '描述某人或某事的名称或名声',
    example: 'He is known as a great writer.',
    exampleTranslation: '他被称为伟大的作家。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },

  // ==================== 完成时态 Perfect Tense ====================

  {
    id: 'ms7_have_been_to',
    phrase: 'have been to',
    phonetic: '/hæv biːn tuː/',
    meaning: '去过（已回来）',
    usageScenario: '描述去过某地且已经回来',
    example: 'I have been to Beijing twice.',
    exampleTranslation: '我去过北京两次。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_have_gone_to',
    phrase: 'have gone to',
    phonetic: '/hæv ɡɒn tuː/',
    meaning: '去了（还没回来）',
    usageScenario: '描述去了某地还未回来',
    example: 'He has gone to Shanghai.',
    exampleTranslation: '他去了上海。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_have_finished',
    phrase: 'have finished',
    phonetic: '/hæv ˈfɪnɪʃt/',
    meaning: '已经完成',
    usageScenario: '描述已经完成的动作',
    example: 'I have finished my homework.',
    exampleTranslation: '我已经完成了作业。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_have_seen',
    phrase: 'have seen',
    phonetic: '/hæv siːn/',
    meaning: '已经看过',
    usageScenario: '描述已经看过的经历',
    example: 'I have seen this movie.',
    exampleTranslation: '我看过这部电影。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_have_lived',
    phrase: 'have lived',
    phonetic: '/hæv lɪvd/',
    meaning: '已经住了',
    usageScenario: '描述居住的经历（现在完成时）',
    example: 'I have lived here for ten years.',
    exampleTranslation: '我在这里住了十年了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_have_studied',
    phrase: 'have studied',
    phonetic: '/hæv ˈstʌdid/',
    meaning: '已经学习了',
    usageScenario: '描述学习的经历',
    example: 'I have studied English for five years.',
    exampleTranslation: '我已经学习英语五年了。',
    category: 'academic',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },

  // ==================== 连接词和状语从句 Conjunctions & Adverbial Clauses ====================

  {
    id: 'ms7_although',
    phrase: 'although...',
    phonetic: '/ɔːlˈðoʊ/',
    meaning: '虽然……',
    usageScenario: '表示让步关系，通常与but不连用',
    example: 'Although it was raining, we went out.',
    exampleTranslation: '虽然下雨了，我们还是出去了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_even_though',
    phrase: 'even though',
    phonetic: '/ˈiːvn ðoʊ/',
    meaning: '即使',
    usageScenario: '表示让步关系，比although语气更强',
    example: 'Even though he is old, he runs fast.',
    exampleTranslation: '即使他老了，他跑得还是很快。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_as_soon_as',
    phrase: 'as soon as',
    phonetic: '/æz suːn æz/',
    meaning: '一……就……',
    usageScenario: '表示一个动作紧接着另一个动作发生',
    example: 'I will call you as soon as I arrive.',
    exampleTranslation: '我一到就给你打电话。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_so_that',
    phrase: 'so that',
    phonetic: '/soʊ ðæt/',
    meaning: '以便/为了',
    usageScenario: '表示目的',
    example: 'I study hard so that I can pass the exam.',
    exampleTranslation: '我努力学习以便通过考试。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_in_order_to',
    phrase: 'in order to',
    phonetic: '/ɪn ˈɔːrdər tuː/',
    meaning: '为了',
    usageScenario: '表示目的，比to更正式',
    example: 'I wake up early in order to catch the bus.',
    exampleTranslation: '我早起是为了赶上公交车。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_such_as',
    phrase: 'such as',
    phonetic: '/sʌtʃ æz/',
    meaning: '例如',
    usageScenario: '举例说明',
    example: 'I like fruits such as apples and bananas.',
    exampleTranslation: '我喜欢水果，例如苹果和香蕉。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_for_example',
    phrase: 'for example',
    phonetic: '/fɔːr ɪɡˈzæmpl/',
    meaning: '例如',
    usageScenario: '举例说明',
    example: 'Many students like sports. For example, Tom plays basketball.',
    exampleTranslation: '许多学生喜欢运动。例如，Tom打篮球。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },

  // ==================== 表达观点和态度 Expressing Opinions ====================

  {
    id: 'ms7_i_believe',
    phrase: 'I believe...',
    phonetic: '/aɪ bɪˈliːv/',
    meaning: '我相信……',
    usageScenario: '表达信念或确信的看法',
    example: 'I believe you can do it.',
    exampleTranslation: '我相信你能做到。',
    category: 'opinions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_in_my_opinion',
    phrase: 'In my opinion...',
    phonetic: '/ɪn maɪ əˈpɪnjən/',
    meaning: '在我看来……',
    usageScenario: '正式地表达个人观点',
    example: 'In my opinion, this is the best way.',
    exampleTranslation: '在我看来，这是最好的方法。',
    category: 'opinions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_from_my_point_of_view',
    phrase: 'From my point of view...',
    phonetic: '/frɒm maɪ pɔɪnt əv vjuː/',
    meaning: '从我的角度来看……',
    usageScenario: '表达个人观点',
    example: 'From my point of view, the plan is good.',
    exampleTranslation: '从我的角度来看，这个计划很好。',
    category: 'opinions',
    difficulty: 'hard',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_as_far_as_i_know',
    phrase: 'As far as I know...',
    phonetic: '/æz fɑːr æz aɪ noʊ/',
    meaning: '据我所知……',
    usageScenario: '表达自己所了解的情况',
    example: 'As far as I know, he is honest.',
    exampleTranslation: '据我所知，他是诚实的。',
    category: 'opinions',
    difficulty: 'hard',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },

  // ==================== 其他常用短语 Other Common Phrases ====================

  {
    id: 'ms7_each_other',
    phrase: 'each other',
    phonetic: '/iːtʃ ˈʌðər/',
    meaning: '互相',
    usageScenario: '表示相互的动作',
    example: 'We help each other.',
    exampleTranslation: '我们互相帮助。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_one_another',
    phrase: 'one another',
    phonetic: '/wʌn əˈnʌðər/',
    meaning: '互相',
    usageScenario: '表示相互的动作，通常用于三者以上',
    example: 'They respect one another.',
    exampleTranslation: '他们互相尊重。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_at_first',
    phrase: 'at first',
    phonetic: '/æt fɜːrst/',
    meaning: '起初',
    usageScenario: '描述开始时的状态',
    example: 'At first, I didn\'t like it.',
    exampleTranslation: '起初我不喜欢它。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_at_last',
    phrase: 'at last',
    phonetic: '/æt læst/',
    meaning: '最后',
    usageScenario: '描述最终的结果',
    example: 'At last, we won the game.',
    exampleTranslation: '最后，我们赢得了比赛。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_at_the_same_time',
    phrase: 'at the same time',
    phonetic: '/æt ðə seɪm taɪm/',
    meaning: '同时',
    usageScenario: '描述同时发生的事情',
    example: 'They arrived at the same time.',
    exampleTranslation: '他们同时到达。',
    category: 'time_place',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_by_the_way',
    phrase: 'by the way',
    phonetic: '/baɪ ðə weɪ/',
    meaning: '顺便说一下',
    usageScenario: '转换话题或补充说明',
    example: 'By the way, what time is it?',
    exampleTranslation: '顺便说一下，几点了？',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_in_fact',
    phrase: 'in fact',
    phonetic: '/ɪn fækt/',
    meaning: '事实上',
    usageScenario: '陈述事实或纠正误解',
    example: 'In fact, I don\'t know him.',
    exampleTranslation: '事实上，我不认识他。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_of_course',
    phrase: 'of course',
    phonetic: '/əv kɔːrs/',
    meaning: '当然',
    usageScenario: '表示肯定或同意',
    example: 'Can you help me? - Of course!',
    exampleTranslation: '你能帮我吗？- 当然！',
    category: 'responses',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_no_doubt',
    phrase: 'no doubt',
    phonetic: '/noʊ daʊt/',
    meaning: '毫无疑问',
    usageScenario: '表示确信',
    example: 'No doubt, he is the best player.',
    exampleTranslation: '毫无疑问，他是最好的选手。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_to_be_honest',
    phrase: 'to be honest',
    phonetic: '/tuː biː ˈɒnɪst/',
    meaning: '老实说',
    usageScenario: '表达真实想法',
    example: 'To be honest, I don\'t like it.',
    exampleTranslation: '老实说，我不喜欢它。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_as_usual',
    phrase: 'as usual',
    phonetic: '/æz ˈjuːʒuəl/',
    meaning: '像往常一样',
    usageScenario: '描述习惯性的状态',
    example: 'He came late as usual.',
    exampleTranslation: '像往常一样，他迟到了。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
  {
    id: 'ms7_according_to',
    phrase: 'according to',
    phonetic: '/əˈkɔːrdɪŋ tuː/',
    meaning: '根据',
    usageScenario: '引用信息来源',
    example: 'According to the report, it will rain.',
    exampleTranslation: '根据报告，将会下雨。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_because_of',
    phrase: 'because of',
    phonetic: '/bɪˈkɒz əv/',
    meaning: '因为',
    usageScenario: '说明原因（后接名词）',
    example: 'We stayed home because of the rain.',
    exampleTranslation: '因为下雨，我们待在家里。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_thanks_to',
    phrase: 'thanks to',
    phonetic: '/θæŋks tuː/',
    meaning: '多亏了',
    usageScenario: '表示感激或归功于',
    example: 'Thanks to your help, I passed the exam.',
    exampleTranslation: '多亏了你的帮助，我通过了考试。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_instead_of',
    phrase: 'instead of',
    phonetic: '/ɪnˈsted əv/',
    meaning: '代替/而不是',
    usageScenario: '表示替代或选择',
    example: 'I chose tea instead of coffee.',
    exampleTranslation: '我选择了茶而不是咖啡。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_at_least',
    phrase: 'at least',
    phonetic: '/æt liːst/',
    meaning: '至少',
    usageScenario: '表示最低限度',
    example: 'You should sleep at least 8 hours.',
    exampleTranslation: '你至少应该睡8小时。',
    category: 'daily_expressions',
    difficulty: 'easy',
    grade: '7',
    level: 'middle',
    frequency: 'high'
  },
  {
    id: 'ms7_at_most',
    phrase: 'at most',
    phonetic: '/æt moʊst/',
    meaning: '至多',
    usageScenario: '表示最高限度',
    example: 'I can wait at most 10 minutes.',
    exampleTranslation: '我最多能等10分钟。',
    category: 'daily_expressions',
    difficulty: 'medium',
    grade: '7',
    level: 'middle',
    frequency: 'medium'
  },
];